import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label, ButtonStandard, ButtonLight, formatMessage } from 'cw-ui-core';
import css from './EnableUserDialog.scss';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React from 'react';

export const ENABLE_USER_DIALOG = 'ENABLE_USER_DIALOG';

const EnableUserDialog = ({ onCancel, onOk, usersCount }) => {
    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={onCancel}
        />,
        <ButtonStandard
            key="ok"
            automationName="ok"
            className={css.enableButton}
            value={formatMessage(Locale.enable)}
            onClick={onOk}
        />,
    ];

    return (
        <Dialog dialogId={ENABLE_USER_DIALOG} header={formatMessage(Locale.enableUser)} buttons={dialogButtons}>
            <div className={css.wrap}>
                <div className={layoutCss.podCol}>
                    <ScreenMessagePanelContainer className={css.screenMessage} screenKey={ENABLE_USER_DIALOG} />
                    <Label value={formatMessage(Locale.enableUsersConfirmation)} />
                    <div className={css.userCountText}>{formatMessage(Locale.usersSelected, { usersCount })}</div>
                </div>
            </div>
        </Dialog>
    );
};

export default injectIntl(EnableUserDialog);
